module.exports = __webpack_public_path__ + "img/icon-track-dark.0ee16f6e.svg";